import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { useContext } from "react";
import { ContextRegisterProduct } from "../context";

export const IndexHooks = () => {
	const { firstFetch } = useContext(ContextRegisterProduct);

	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			param: '{"id": 1,"label":"Descrição","value":"nome"}',
			paramValue: "",
			active: true,
			tipoproduto: "pai",
		},
	});

	const paramSelected = watch("param");
	const tipoprodutoSelected = watch("tipoproduto");

	const handleOnSubmit = async (data) => {
		let ativo = "NAO";
		if (data.active === true) ativo = "SIM";

		const newData = {
			param: JSON.parse(data.param).value,
			paramValue: data.paramValue,
			ativo,
			active: data.active,
			tipoproduto: data.tipoproduto,
		};

		await firstFetch(newData);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		tipoprodutoSelected,
		setFocus,
		control,
		Controller,
	};
};
